/**
 * Scroll-driven video — AARKA
 * Same behavior on all devices:
 * Video.currentTime scrubbed by scroll position.
 * Text markers appear/disappear based on scroll progress.
 * Uses GSAP ScrollTrigger for pinning, scrubbing, and snapping.
 */
if (!customElements.get('aarka-scroll-video')) {
  customElements.define('aarka-scroll-video', class extends HTMLElement {

    connectedCallback() {
      if (window.AARKA && window.AARKA.ready) {
        this.init();
      } else {
        document.addEventListener('aarka:scroll-ready', () => this.init(), { once: true });
      }
    }

    disconnectedCallback() {
      if (this.st) this.st.kill();
      if (this.markerTriggers) this.markerTriggers.forEach(function (t) { t.kill(); });
    }

    init() {
      var ScrollTrigger = window.AARKA.ScrollTrigger;

      this.wrapper = this.querySelector('.sv-wrapper');
      this.sticky = this.querySelector('.sv-sticky');
      this.markers = Array.from(this.querySelectorAll('.sv-marker'));
      this.multiplier = parseInt(this.getAttribute('data-multiplier') || '4', 10);
      this.dataType = this.getAttribute('data-type') || 'mp4';

      // Pick the right video for device
      var isMobile = window.innerWidth < 750;
      var mobileVideo = this.querySelector('.sv-video--mobile');
      var desktopVideo = this.querySelector('.sv-video--desktop');
      if (mobileVideo && desktopVideo) {
        this.video = isMobile ? mobileVideo : desktopVideo;
      } else {
        this.video = this.querySelector('.sv-video');
      }

      if (!this.wrapper) return;

      // Set wrapper height for scroll runway
      this.wrapper.style.height = (this.multiplier * 100) + 'vh';

      var self = this;
      var videoReady = false;

      if (this.video && this.dataType === 'mp4') {
        // Pause immediately — we control playback via currentTime
        this.video.pause();

        if (this.video.readyState >= 1) {
          videoReady = true;
        } else {
          this.video.addEventListener('loadedmetadata', function () {
            videoReady = true;
          }, { once: true });
        }
      }

      // Build snap points from marker positions (plus start and end)
      var snapPoints = [0];
      this.markers.forEach(function (marker) {
        var pos = parseInt(marker.getAttribute('data-position') || '50', 10) / 100;
        snapPoints.push(pos);
      });
      snapPoints.push(1);
      // Deduplicate and sort
      snapPoints = snapPoints.filter(function (v, i, a) { return a.indexOf(v) === i; });
      snapPoints.sort(function (a, b) { return a - b; });

      this.st = ScrollTrigger.create({
        trigger: this.wrapper,
        start: 'top top',
        end: 'bottom bottom',
        pin: this.sticky,
        scrub: 0.5,
        snap: {
          snapTo: snapPoints,
          duration: { min: 0.2, max: 0.5 },
          delay: 0.05,
          ease: 'power1.inOut',
          inertia: false
        },
        onUpdate: function (st) {
          var progress = st.progress;

          // Scrub video
          if (self.video && videoReady && self.video.duration) {
            var targetTime = progress * self.video.duration;
            if (Math.abs(self.video.currentTime - targetTime) > 0.05) {
              self.video.currentTime = targetTime;
            }
          }

          // Update markers — +/- 10% window so text stays visible longer at snap points
          var windowSize = 0.10;
          self.markers.forEach(function (marker) {
            var pos = parseInt(marker.getAttribute('data-position') || '50', 10) / 100;
            var isActive = progress >= (pos - windowSize) && progress <= (pos + windowSize);
            marker.classList.toggle('sv-marker--active', isActive);
          });
        }
      });
    }
  });
}
